<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableRedis",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          minWidth: 150,
          key: "accountName",
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.accountID"),
          minWidth: 150,
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.GCP.Redis.projectId"),
          minWidth: 150,
          key: "projectId",
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.region"),
          minWidth: 150,
          key: "locationId",
        },
        {
          title: this.$t("RAM.ALI.Redis.instanceName"),
          minWidth: 150,
          key: "displayName",
        },
        {
          title: this.$t("RAM.GCP.Redis.cacheClusterId"),
          minWidth: 150,
          key: "nodeName",
        },
        {
          title: this.$t("RAM.GCP.Redis.state"),
          minWidth: 150,
          key: "state",
        },
        {
          title: this.$t("RAM.GCP.Redis.version"),
          minWidth: 150,
          key: "redisVersion",
        },
        {
          title: this.$t("RAM.GCP.Redis.cache"),
          minWidth: 150,
          key: "memorySizeGb",
        },

        {
          title: this.$t("RAM.GCP.Redis.timeCreated"),
          minWidth: 150,
          key: "createdTime",
          fixed: "right",
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (companyId) {
      tableDataVue.companyId = companyId;
    });
    eventBus.$on("accountName", function (accountName) {
      tableDataVue.accountName = accountName;
    });
    eventBus.$on("accountIdList", function (accountIdList) {
      tableDataVue.accountIdList = accountIdList;
    });
    eventBus.$on("displayName", function (displayName) {
      tableDataVue.displayName = displayName;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (companyId) {
        tableDataVue.companyId = companyId;
      });
      eventBus.$on("accountName", function (accountName) {
        tableDataVue.accountName = accountName;
      });
      eventBus.$on("accountIdList", function (accountIdList) {
        tableDataVue.accountIdList = accountIdList;
      });
      eventBus.$on("displayName", function (displayName) {
        tableDataVue.displayName = displayName;
      });

      this.$api.resourceManagement
        .pagingQueryGcpRedis({
          pageNum: this.current,
          pageSize: this.pageSize,
          accountIdList: tableDataVue.accountIdList,
          displayName: tableDataVue.displayName,
          companyId: tableDataVue.companyId,
          accountName: tableDataVue.accountName,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/redis/TableRedis.vue